import React from 'react';

function CardPost(props) {
    const { outSide, inside, content, data } = props;
    return (
        <div className={outSide} data-role={data}>
            <div className={inside}>
                <span>{content}</span>
            </div>
        </div>
    );
}

export default CardPost;
